// services/collections.ts
import {
  apiClient,
  ApiError,
  ApiResponse,
  PaginatedApiResponse,
} from "@/lib/apiClient";
import { Category } from "@/types/models/category";

export const getCategories = async ({
  page,
  pageSize,
}: {
  page: number;
  pageSize: number;
}): Promise<PaginatedApiResponse<Category[]>> => {
  try {
    const data: PaginatedApiResponse<Category[]> = await apiClient.getPaginated(
      "/api/v1/admin/:storeId/collections",
      {
        page: page.toString(),
        page_size: pageSize.toString(),
      },
    );
    return data;
  } catch (error: unknown) {
    if (error instanceof ApiError) {
      throw error;
    }
    throw new ApiError(500, "UNKNOWN_ERROR", "An unexpected error occurred");
  }
};
export const putCategories = async ({
  collectionId,
  data,
}: {
  collectionId: string;
  data: Partial<Category>;
}): Promise<ApiResponse<Category>> => {
  try {
    const response: ApiResponse<Category> = await apiClient.put(
      `/api/v1/admin/:storeId/collections/${collectionId}`,
      data,
    );
    return {
      data: response.data,
      status: response.status,
      message: response.message,
      success: response.success,
      valid: response.valid,
    };
  } catch (error: unknown) {
    if (error instanceof ApiError) {
      throw error;
    }
    throw new ApiError(500, "UNKNOWN_ERROR", "An unexpected error occurred");
  }
};
export const postCategories = async ({
  data,
}: {
  data: Partial<Category>;
}): Promise<ApiResponse<Category>> => {
  try {
    const response: ApiResponse<Category> = await apiClient.post(
      `/api/v1/admin/:storeId/collections`,
      data,
    );
    return {
      data: response.data,
      status: response.status,
      message: response.message,
      success: response.success,
      valid: response.valid,
    };
  } catch (error: unknown) {
    if (error instanceof ApiError) {
      throw error;
    }
    throw new ApiError(500, "UNKNOWN_ERROR", "An unexpected error occurred");
  }
};
export const deleteCategories = async ({
  id,
}: {
  id: string;
}): Promise<ApiResponse<Category>> => {
  try {
    const response: ApiResponse<Category> = await apiClient.delete(
      `/api/v1/admin/:storeId/collections/${id}`,
    );
    return {
      data: response.data,
      status: response.status,
      message: response.message,
      success: response.success,
      valid: response.valid,
    };
  } catch (error: unknown) {
    if (error instanceof ApiError) {
      throw error;
    }
    throw new ApiError(500, "UNKNOWN_ERROR", "An unexpected error occurred");
  }
};
